(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Matic", [], factory);
	else if(typeof exports === 'object')
		exports["Matic"] = factory();
	else
		root["Matic"] = factory();
})(window, function() {
return 